import * as React from "react";
const SvgUpArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 7, viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 6L5.5 2L1 6", stroke: "black", strokeWidth: 1.5 }));
export {
  SvgUpArrow as S
};
//# sourceMappingURL=up_arrow-BZ6O1kyX.js.map
